import { render, staticRenderFns } from "./BiorunLottery.vue?vue&type=template&id=42bf07ea&scoped=true&"
import script from "./BiorunLottery.vue?vue&type=script&lang=js&"
export * from "./BiorunLottery.vue?vue&type=script&lang=js&"
import style0 from "./BiorunLottery.vue?vue&type=style&index=0&id=42bf07ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42bf07ea",
  null
  
)

export default component.exports